import { AppUrls } from '@/urls';
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { apiSdk } from '@/httpClient';
import FormItem from '@/components/Form/FormItem';
import { UNKNOWN_ERROR_MESSAGE } from '@/config';
import Spin from '@/components/Spin';
import { FormValidation } from '@/helpers/formValidations';
import { ModalUtils } from '@/contexts/ModalWrapper';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const forgotPassword = (values: any) => {
    setLoading(true);
    apiSdk.AgentUserService.forgotPassword({
      body: {
        emailAddress: values.email,
        userName: values.userName,
      },
    })
      .then(res => {
        if (res.success) {
          ModalUtils.success({
            content: t('SEND_MAIL_FORGOT_PASSWORD_SUCCESS'),
            onClose: () => {
              history.push(AppUrls.Login);
            },
          });
        } else {
          ModalUtils.error({
            content: t(res.message || UNKNOWN_ERROR_MESSAGE),
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="layout-pt-lg layout-pb-lg bg-blue-2">
      <Helmet>
        <title>Forgot password</title>
      </Helmet>
      <div className="container">
        <div className="row justify-center">
          <div className="col-xl-6 col-lg-7 col-md-9">
            <Spin loading={loading}>
              <div className="px-50 py-50 sm:px-20 sm:py-20 bg-white shadow-4 rounded-4">
                <form className="row y-gap-20" onSubmit={handleSubmit(forgotPassword)}>
                  <div className="col-12">
                    <h1 className="text-22 fw-500">{t('forgotPasswordPage_TitleForgotPassword')} </h1>
                    <p className="mt-10">{t('forgotPasswordPage_EmailAddress')}</p>
                  </div>

                  <div className="col-12">
                    <FormItem errors={errors} label={t('base.Email')} name="email">
                      <input {...register('email', FormValidation.Required)} />
                    </FormItem>
                  </div>
                  <div className="col-12">
                    <FormItem errors={errors} label={t('base.UserName')} name="userName">
                      <input {...register('userName', FormValidation.Required)} />
                    </FormItem>
                  </div>

                  <div className="col-12">
                    <Link to={AppUrls.Login} className="text-blue-1">
                      {t('base.BackLoginPage')}
                    </Link>
                  </div>

                  <div className="col-12">
                    <button type="submit" className="button py-20 -dark-1 bg-blue-1 text-white w-100">
                      {t('base.Submit')}
                      <div className="icon-arrow-top-right ml-15" />
                    </button>
                  </div>
                </form>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </section>
  );
}
